export const getTargetOrigin = (): string => {
  let targetOrigin = '*';
  if (process.env.REACT_APP_GDS_ENV === 'production') {
    targetOrigin = 'https://www.theknot.com';
  } else if (process.env.REACT_APP_GDS_ENV === 'qa') {
    targetOrigin = 'https://qa-beta.theknot.com';
  }

  return targetOrigin;
};
